// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EvVJ","largestCol":"styles_largestCol__31FTt","smallestCol":"styles_smallestCol__6__TW"};